import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
	useTanstackTable,
	createColumnHelper,
	EMPTY_ARRAY,
} from "../../../hooks/useTanstackTable";
import { useApi } from "../../../hooks/useApi";
import type { EmpresaDatosAnio } from "../../../@types/Api_Extracted";
import { Button } from "../../ui/button";
import { DataTable } from "../../ui/datatable";
import {
	getFilteredRowModel,
	getPaginationRowModel,
} from "@tanstack/react-table";
import { Paginator } from "../../ui/paginator";

export function DatosAnioListTable() {
	const navigate = useNavigate();

	const api = useApi();
	const query = api.useQuery("get", "/v1/Empresa/DatosAnio", {});

	const handleNewInput = () => {
		navigate("input/new");
	};

	const columns = useMemo(Columns, []);
	const table = useTanstackTable({
		columns,
		data: query.data?.sort((a, b) => b.anio - a.anio) ?? EMPTY_ARRAY,
		getPaginationRowModel: getPaginationRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
	});

	const tableState = table.getState();
	return (
		<>
			<DataTable
				table={table}
				noResultsMessage="Aún no hay datos registrados"
				errorMessage="Error al cargar los datos"
				isLoading={query.isPending}
				isError={query.isError}
			/>
			<div className="flex items-center justify-between mt-4">
				<div>
					{table.getPageCount() != 0 && (
						<Paginator
							pageCount={table.getPageCount()}
							pageIndex={tableState.pagination.pageIndex}
							shownPages={5}
							onPageChange={table.setPageIndex}
							canPrevious={table.getCanPreviousPage()}
							canNext={table.getCanNextPage()}
						/>
					)}
				</div>
				<Button variant="primary" onClick={handleNewInput}>
					Nuevo año
				</Button>
			</div>
		</>
	);
}

function Columns() {
	const columnHelper = createColumnHelper<EmpresaDatosAnio>();

	return [
		columnHelper.accessor("anio", {
			header: "Año",
			cell: (props) => props.getValue(),
		}),
		columnHelper.accessor("cantidadTrabajadores", {
			header: "Trabajadores",
			cell: (props) => props.getValue(),
		}),
		columnHelper.accessor("materiaPrima", {
			header: "Materia Prima",
			cell: (props) => props.getValue() + " kg",
		}),
		columnHelper.accessor("desechos", {
			header: "Desechos",
			cell: (props) => props.getValue() + " kg",
		}),
		columnHelper.accessor("facturacion", {
			header: "Facturación",
			cell: (props) => props.getValue() + " €",
		}),
		columnHelper.display({
			id: "acciones",
			header: "Acciones",
			cell: (props) => <AccionesFila fila={props.row.original} />,
		}),
	];
}

function AccionesFila(props: { fila: EmpresaDatosAnio }) {
	const navigate = useNavigate();
	const handleEdit = () => {
		navigate("input/" + props.fila.anio);
	};

	return (
		<div className="grid grid-cols-1 gap-2">
			<Button variant="secondary" onClick={handleEdit}>
				Editar
			</Button>
		</div>
	);
}
